import React from 'react';
import { formatValuesForDisplayBasedOnType } from '@shared/utils/strings';
import { EditCurrencyField } from '@shared/components/tables/column-components/edit-currency-field/edit-currency-field';
import { useBudgetManagerClusters } from '@domain/budget-manager/budget-manager-clusters.hook';
import { useLoggedUser } from '@domain/logged-user';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';
import isNull from 'lodash/isNull';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';
import { MULTIPLE_STRATEGIES } from '@domain/segments/segments-table/segments-table.constants';
import { getClusterByName } from '../cluster.utils';
import {
    isFieldLoading, isTotalColumn, isUntagged,
} from './campaign-table-cluster.utils';
import { ClusterSwitchLoading } from './campaign-table-cluster-styles';

interface NumberFieldEditProps {
    value: number
    precision?: number
    type?: string
    key: string
    prefix?: string
    suffix?: string
    field: string
    row: any
}

export const ClusterNumberFieldEdit = ({
    value,
    row,
    key,
    field,
    type = METRICS_TYPES.currency,
    prefix = '',
    suffix = '',
    precision = 2,
}: NumberFieldEditProps) => {
    const {
        clusters,
        updatedCluster,
        updatedClusterState,
        updateCluster,
    } = useBudgetManagerClusters();
    const { loggedUser } = useLoggedUser();
    const { values: { cluster_name: clusterName = '', bidStrategy } } = row;
    const cluster = getClusterByName(clusters, clusterName);
    const {
        minimumPerformanceValue,
        [field]: {
            getFieldDefaultValue,
            updateClusterField,
            getFieldActualValue,
        },

    } = CLUSTER_FIELDS_FUNCTIONS;

    if (isTotalColumn(clusterName)) {
        return formatValuesForDisplayBasedOnType(value, type);
    }

    if (isUntagged(clusterName)) return null;

    if (isFieldLoading({
        cluster, updatedCluster, updatedClusterState,
    })) {
        return <ClusterSwitchLoading />;
    }

    const isEmptyValue = newValue => (newValue === 0 || isNull(newValue));

    const handleChangeField = (entryValue: number) => {
        const newValue = isEmptyValue(entryValue)
            ? getFieldDefaultValue(fieldValue) : entryValue;
        const newCluster = updateClusterField(cluster, newValue);

        updateCluster({
            clusterId: cluster.id,
            organizationId: cluster.organizationId,
            userId: loggedUser.id,
            cluster: newCluster,
        });
        return true;
    };

    const fieldValue = getFieldActualValue(cluster);

    const isDisabled = () => field === minimumPerformanceValue.field
     && bidStrategy === MULTIPLE_STRATEGIES;

    return (
        <EditCurrencyField
            defaultValue={parseFloat(fieldValue)}
            currency={prefix}
            suffix={suffix}
            precision={precision}
            key={`key-${clusterName}-${key}`}
            onChange={handleChangeField}
            field={field}
            disabled={isDisabled()}
        />
    );
};
